/**
 * Fusion product card — weight/option chips update price + add-to-cart variant.
 */
(function () {
  function applyChip(card, chip) {
    if (!card || !chip) return;

    const variantId = chip.getAttribute('data-variant-id');
    const price = chip.getAttribute('data-price') || '';
    const compare = chip.getAttribute('data-compare') || '';
    const offer = chip.getAttribute('data-offer') || '';
    const available = chip.getAttribute('data-available') === 'true';
    const addLabel = chip.getAttribute('data-add-label') || 'ADD';
    const soldOut = chip.getAttribute('data-sold-out') || 'Sold out';

    const variantInput = card.querySelector('[data-fusion-pcard-variant]');
    const addBtn = card.querySelector('[data-fusion-pcard-add]');
    const addLabelEl = card.querySelector('[data-fusion-pcard-add-label]');
    const saleEl = card.querySelector('[data-fusion-pcard-sale]');
    const mrpEl = card.querySelector('[data-fusion-pcard-mrp]');
    const offerEl = card.querySelector('[data-fusion-pcard-offer]');
    const flagEl = card.querySelector('[data-fusion-pcard-discount-flag]');
    const flagPctEl = card.querySelector('[data-fusion-pcard-discount-pct]');
    const offerPctMatch = String(offer).match(/(\d+)\s*%/);
    const offerPct = offerPctMatch ? offerPctMatch[1] + '%' : '';

    if (variantInput && variantId) {
      variantInput.value = variantId;
      variantInput.disabled = !available;
    }

    if (saleEl) saleEl.textContent = price;

    if (mrpEl) {
      if (compare) {
        mrpEl.textContent = compare;
        mrpEl.hidden = false;
      } else {
        mrpEl.textContent = '';
        mrpEl.hidden = true;
      }
    }

    if (offerEl) {
      if (offer) {
        offerEl.textContent = offer;
        offerEl.hidden = false;
      } else {
        offerEl.textContent = '';
        offerEl.hidden = true;
      }
    }

    if (flagEl) {
      if (offerPct) {
        if (flagPctEl) flagPctEl.textContent = offerPct;
        flagEl.hidden = false;
      } else {
        flagEl.hidden = true;
      }
    }

    if (addBtn) {
      addBtn.disabled = !available;
    }
    if (addLabelEl) {
      addLabelEl.textContent = available ? addLabel : soldOut;
    }

    card.querySelectorAll('[data-fusion-pcard-chip]').forEach(function (btn) {
      const on = btn === chip;
      btn.classList.toggle('fusion-pcard__chip--active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function onClick(event) {
    const chip = event.target.closest('[data-fusion-pcard-chip]');
    if (!chip) return;
    const card = chip.closest('[data-fusion-pcard]');
    if (!card) return;
    event.preventDefault();
    applyChip(card, chip);
  }

  document.addEventListener('click', onClick);
})();
